export default "__VITE_ASSET__6WAcm_iS__ 1600w, __VITE_ASSET__OVuG7e6___ 800w";